import { Capacitor } from '@capacitor/core'

// Links that leave the app — signup confirmation emails, invite links texted to
// a family member — must point at the deployed web app.
//
// Inside the Capacitor shell `window.location.origin` is `capacitor://localhost`
// (iOS) or `https://localhost` (Android). Those resolve to the app's own bundled
// assets, so a link built from them is dead the moment it lands in someone's
// inbox. On the web the live origin is still the right answer: it keeps localhost
// dev and Netlify deploy previews self-consistent.
const CONFIGURED = (process.env.REACT_APP_PUBLIC_URL || '').replace(/\/+$/, '')
const DEPLOYED_ORIGIN = 'https://app.getmapacare.com'

export function publicOrigin() {
  if (Capacitor.isNativePlatform()) return CONFIGURED || DEPLOYED_ORIGIN
  return CONFIGURED || window.location.origin
}

export function publicUrl(path = '/') {
  return `${publicOrigin()}${path.startsWith('/') ? path : `/${path}`}`
}
